<template>
    <div class="nav_container">
        <div class="nav_icon">
            <ul>
                <li class="nav_icon_dropdown" :class="{ active: isDropdownOpenStock }">
                    <div>
                        <a href="#" @click="toggleDropdown('stock')">
                            <i class="material-icons">warehouse</i>
                        </a>
                        <p>Stockage</p>
                    </div>
                </li>
                <li class="nav_icon_dropdown" :class="{ active: isDropdownOpenClient }">
                    <a href="#" @click="toggleDropdown('client')">
                        <i class="material-icons">group_add</i>
                    </a>
                    <p> Client</p>
                </li>
            </ul>
        </div>
        <div class="nav_item">

            <ul v-if="isDropdownOpenStock">
                <li class="nav_item_item"><router-link to="/admin/dashboard">Fluctuation du Stock</router-link></li>
                <li class="nav_item_item"><router-link to="/admin/stock/index">Stock</router-link></li>
                <li class="nav_item_item"><router-link to="/admin/categorie/index">Catégorie</router-link></li>
                <li class="nav_item_item"><router-link to="/admin/zoneStockage/index">Zone de stockage</router-link>
                </li>
                <li class="nav_item_item"><router-link to="/admin/fournisseur/index">Fournisseur</router-link></li>
            </ul>

            <ul v-if="isDropdownOpenClient">
                <li class="nav_item_item"><router-link to="/admin/client/index">Client</router-link></li>
                <li class="nav_item_item"><router-link to="/admin/planning/index">Planning</router-link></li>
            </ul>

        </div>
    </div>

</template>

<script>
export default {
    name: 'AdminNav',
    data() {
        return {
            isDropdownOpenStock: false,
            isDropdownOpenClient: false,
        };
    },
    methods: {
        toggleDropdown(menu) {
            if (menu === 'stock') {
                this.isDropdownOpenStock = !this.isDropdownOpenStock;
                this.isDropdownOpenClient = false;
            } else if (menu === 'client') {
                this.isDropdownOpenClient = !this.isDropdownOpenClient;
                this.isDropdownOpenStock = false;
            }
        },
    },
}
</script>

<style>
li {
    list-style: none;
}

a {
    cursor: pointer;
}




.nav_container {
    display: flex;
    height: 100lvh;
}

.nav_icon {
    width: 100px;
    background-color: #143D60;
    display: flex;
    flex-direction: column;
    padding: 0;
}

.nav_icon ul {
    list-style: none;
    padding: 0;
    margin: 0;
}

.nav_icon li {
    text-align: center;
    width: 100%;
    box-sizing: border-box;
    padding: 10px;
}

.nav_icon i {
    font-size: 35px;

    cursor: pointer;
}

.nav_icon p {
    font-size: 15px;
    cursor: pointer;
    margin: 0;
    font-weight: bold;
}

.nav_item {
    flex: 1;
    background-color: #578FCA;
}

.nav_item ul {
    list-style: none;
    padding: 0;
    font-size: 21px;
    width: 150px;
}

.nav_item ul li {
    width: 100%;
    text-align: left;
}


.nav_item_item a {
    text-decoration: none;
    display: block;
    color: #143D60;
    padding: 10px;
}

.nav_item ul li:hover {
    background-color: #143D60;
}

.nav_item_item a:hover {
    color: rgba(237, 87, 62, 1);
}

.nav_icon_dropdown {
    color: rgba(237, 87, 62, 1);
}

.nav_icon_dropdown .material-icons {
    color: rgba(237, 87, 62, 1);
}

.nav_icon_dropdown.active {
    background-color: #578FCA;
    color: #143D60;
}

.nav_icon_dropdown.active .material-icons {
    color: #143D60;
}
</style>
